import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import { useNavigate, useParams } from "react-router-dom";
import TrendsTab from "./tabs/trends.tab";
import SurveyResultsPage from "../survey-results/survey-results.page";
import OverviewTab from "./tabs/overview.tab";


const ResultsPage = () => {
  useSetPageTitle('Reports');
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();
  const { extSurveyId } = useParams<{ extSurveyId?: string }>();

  const reportsTabs = [
    {
      id: 'overview',
      key: 'ALL',
      label: 'Overview',
    },
    {
      id: 'preview',
      key: 'NEVER',
      label: 'Overview (Beta)',
    },
    {
      id: 'trends',
      key: 'ALL',
      label: 'Trends',
    },
    // {
    //   id: 'analysis',
    //   key: 'analysis',
    //   label: 'Analysis',
    // },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = reportsTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    if (clientId) {
      navigate(`/client/${clientId}/results/${tabId}/${extSurveyId}`);
    } else {
      navigate(`/results/${tabId}/${extSurveyId}`);
    }
  };

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/results"
      navbarProps={{
        showBackButton: false,
        backPath: clientId ? `/client/${clientId}/reports` : '/surveys',
        tabs: reportsTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {currentTab === '' || currentTab === 'overview' && <SurveyResultsPage />}
        {currentTab === 'preview' && <OverviewTab />}
        {currentTab === 'trends' && <TrendsTab />}
        {/* {currentTab === 'analysis' && <AnalysisTab />} */}
      </div>
    </AppLayout>
  );
};

export default ResultsPage;